import { Entity, Identifier, Serializer } from 'ddd-base';
import { CloudId } from '@/models/domain/CloudId';

export class AuthParamsIdentifier extends Identifier<string> {}

const id = new AuthParamsIdentifier('authParams');

export const AuthParamsConverter: Serializer<AuthParams, AuthParamsJSON> = {
    fromJSON(json) {
        return new AuthParams({
            id,
            cloudId: new CloudId({ value: json.cloudId || '' }),
            loginMethod: json.loginMethod,
        });
    },
    toJSON(entity: AuthParams): AuthParamsJSON {
        return {
            id: entity.id.toValue(),
            cloudId: entity.cloudId?.value,
            loginMethod: entity.loginMethod,
        };
    },
};

export const createAuthParams = () => {
    return new AuthParams({
        id,
    });
};

export type LoginMethod = 'nextAccount' | 'sso';

export interface AuthParamsJSON {
    readonly id?: string;
    readonly cloudId?: string;
    readonly loginMethod?: LoginMethod;
}

export interface AuthParamsProps {
    readonly id: AuthParamsIdentifier;
    readonly cloudId?: CloudId;
    readonly loginMethod?: LoginMethod;
}

export class AuthParams extends Entity<AuthParamsProps> implements AuthParamsProps {
    readonly id: AuthParamsIdentifier;
    readonly cloudId?: CloudId;
    readonly loginMethod?: LoginMethod;

    constructor(props: AuthParamsProps) {
        super(props);
        this.id = props.id;
        this.cloudId = props.cloudId;
        this.loginMethod = props.loginMethod;
    }

    get name() {
        return this.props.id.toString();
    }

    updateCloudId(cloudId: CloudId) {
        return new AuthParams({
            ...this.props,
            cloudId,
        });
    }

    updateLoginMethod(loginMethod: LoginMethod) {
        return new AuthParams({
            ...this.props,
            loginMethod,
        });
    }

    hasCloudId() {
        return !!this.cloudId?.value;
    }

    hasLoginMethod() {
        return !!this.loginMethod;
    }

    /**
     * 実行側のAuthParamsを引数のAuthParamsで上書きをする
     */
    join(other: AuthParams): AuthParams {
        return new AuthParams({
            id,
            cloudId: this.cloudId ? this.cloudId.join(other.cloudId) : other.cloudId,
            loginMethod: other.props.loginMethod ?? this.props.loginMethod,
        });
    }
}
